<template>
    <div class="rating-driver">
        <div class="stars-wrapper">
            <p v-if="rate > 0" class="rate-des">{{ $t(`SHARE_ORDER.RATING.LEVEL.${rate}`) }}</p>
            <p v-else class="rate-des"></p>
            <Star
                v-for="n in 5"
                :key="n"
                :rated="rate >= n"
                :value="n"
                @onClick="handleClickStar"
            />
        </div>
        <p class="label-rating">{{selectReasonTitle}}</p>
        <div class="badge-rating">
            <div v-if="rate === 5" class="reasons equal-5-stars">
                <div @click="onSelectReason(reason)" class="reason" v-for="reason in reasonPositive" :key="reason.key">
                    <img :class="{'active' : isActiveReason(reason)}" width="64" height="64" :src="reason.image_url" :alt="reason.name">
                    <p>{{reason.name}}</p>
                </div>
            </div>
            <div v-else class="reasons less-5-stars">
                <div @click="onSelectReason(reason)" :class="{'active' : isActiveReason(reason)}" class="reason" v-for="reason in reasonNegative" :key="reason.key">
                    <span>{{reason.text}}</span>
                </div>
            </div>
        </div>
        <div class="leave-feedback" @click="handleLeaveFeedback" v-if="!visibleTextarea">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7Z" fill="#FF8200"/>
            </svg>
            <span>{{ $t(`SHARE_ORDER.rating_driver.leave_feedback`)}}</span>
        </div>
        <div class="feedback-rating" v-else>
            <textarea v-model="comment" @input="handleChangeTextArea" :placeholder="$t(`SHARE_ORDER.rating_driver.placeholder_textarea`)" rows="5"></textarea>
            <p>{{$t(`SHARE_ORDER.rating_driver.limit_characters`, {numbers : 6})}}</p>
        </div>
        <div class="submit">
            <button class="btn-submit"
                :class="{'active' : visibleSubmit}" 
                @click="visibleSubmit ? handleSubmit() : ''">
                {{ $t(`SHARE_ORDER.rating_driver.submit`)}}
            </button>
        </div>
    </div>
</template>
<script>
import Star from './rating/Star'
// export const findIndex = require("lodash/findIndex")
import axios from "axios";

const PERFECT_RATE = 5
export default {
    components : {
        Star
    },
    props: { 
        initRate: Number,
        order : Object
    },
    computed : {
        selectReasonTitle() {
            let rateNumber = this.rate;
            let title = rateNumber < 3 ? "bad" : rateNumber < 5 ? "mid" : "good";
            return this.$t("SHARE_ORDER.rating_driver.select_reason_title." + title);
        },
    },

    data() {
        return {
            rate: this.initRate || 0,
            reasonPositive: [],
            reasonNegative: [],
            selectedReasons: [],
            comment : '',
            visibleSubmit : false,
            visibleTextarea : false,
            sortingFeedbackData : {
                1 : ["reason_1","reason_6","reason_7","reason_2","reason_5","reason_3","reason_4"],
                2 : ["reason_7","reason_6","reason_1","reason_5","reason_2","reason_3","reason_4"],
                3 : ["reason_5","reason_2","reason_7","reason_6","reason_1","reason_3","reason_4"],
                4 : ["reason_3","reason_4","reason_5","reason_2","reason_7","reason_6","reason_1"]
            },
            rateFormData: {},
        }
    },
    methods : {
        handleClickStar (value) {
            this.visibleTextarea = false
            this.rate = value
            this.comment = ''
            this.selectedReasons.length = 0

            if(value === PERFECT_RATE || this.rate === PERFECT_RATE) {
                this.visibleSubmit = true
            }else{
                this.visibleSubmit = false
                this.reasonNegative.sort((a, b) => this.sortingFeedbackData[value].indexOf(a.key) - this.sortingFeedbackData[value].indexOf(b.key));
            }

        },
        handleLeaveFeedback() {
            this.visibleTextarea = true
        },
        handleChangeTextArea($event){
            this.comment = $event.target.value

            if(this.rate === PERFECT_RATE) {
                if(this.comment.length >= 6 || this.comment.length === 0) {
                    this.visibleSubmit = true
                }else{
                    this.visibleSubmit = false
                }
            }else{
                
                if(this.comment.length >= 6) {
                    this.visibleSubmit = true
                }else{
                    this.visibleSubmit = false
                }

                if(this.comment.length == 0 && this.selectedReasons && this.selectedReasons.length !== 0) {
                    this.visibleSubmit = true
                }
            }
        },
        onSelectReason(reason) {
            const reasonIndex = this.selectedReasons && this.selectedReasons.findIndex(r => { return r.key === reason.key })
            // findIndex(this.selectedReasons, { key: reason.key });
            if (reasonIndex > -1) {
                this.selectedReasons.splice(reasonIndex, 1);
            } else {
                this.selectedReasons.push(reason);
            }

            if(this.rate < PERFECT_RATE){
                if(this.selectedReasons && this.selectedReasons.length > 0){
                    if(!this.comment || this.comment.length == 0) {
                        this.visibleSubmit = true
                    }else {
                        if(this.comment.length >= 6) {
                            this.visibleSubmit = true
                        }else{
                            this.visibleSubmit = false
                        }
                    }
                } else {
                    if(this.comment.length >= 6) {
                        this.visibleSubmit = true
                    } else {
                        this.visibleSubmit = false
                    }
                }
            }
        },
        isActiveReason(reason) {
            const reasonIndex = this.selectedReasons && this.selectedReasons.findIndex(r => { return r.key === reason.key })
            // findIndex(this.selectedReasons, { key: reason.key });
            return reasonIndex > -1 ? true : false;
        },

        handleSubmit() {
            if(this.rate < PERFECT_RATE) { 
                let comments = this.selectedReasons.map(reason => {
                    return reason.value;
                });
                this.rateFormData.rate = this.rate
                this.rateFormData.comment = comments.join(" ") + " " +  this.comment.trim();
                this.rateFormData.comment = this.rateFormData.comment.trim();

                if(this.rateFormData.badge_ids) delete this.rateFormData.badge_ids;
                this.createTicket();

                this.$emit('onUpdateRating', this.rateFormData)
            } else {
                let comments = this.selectedReasons.map(reason => {
                    return reason.key;
                });
                this.rateFormData.rate = this.rate
                this.rateFormData.comment = this.comment.trim()
                this.rateFormData.badge_ids = comments.join(",")

                this.$emit('onUpdateRating', this.rateFormData)
            }
            this.rateFormData.order_id = this.order._id
            this.rateFormData.user_id = this.order.user_id

            if (this.$route.params.tracking_number) {
                const path_index = this.order && this.order.path && this.order.path.length > 0 && this.order.path[1].path_index;
                this.rateFormData.pathIndex = path_index
            }
            this.$store.dispatch('ratingSupplier', this.rateFormData).then(response => {
                if(response && response.status === 200){
                    this.$emit('onUpdateRating', this.rateFormData)
                    this.$store.dispatch('setRate', this.rateFormData.rate)
                }
            }).catch(err => {
                console.log("ratingSupplier err", err)
            })
        },

        createTicket() {
            let ticket = {
                subject: `RECEIVER : BAD RATING - ${this.rateFormData.rate}*`,
                order_id: this.order._id,
                type: "ahamove_bad_rating",
                token: this.order.user_id,
                description: `Rating: ${this.rateFormData.rate}* \n Reason: ${this.rateFormData.comment} \n Summit From: ${window.location}`
            };
            return new Promise((resolve, reject) => {
                const api = process.env.VUE_APP_API_URL.concat(
                    this.$constants.API.order.create_ticket
                );
                axios.get(api, { params: ticket })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },
    
    },
    created() {
        let bagdeList = 
        [
            {
                "type": "supplier",
                "name": this.$t('SHARE_ORDER.rating_driver.thanksfull.enthusiastic'),
                "image_url": "https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Badges+icon/enthusiastic_icon.png",
                "key": "SUPPLIER_ENTHUSIASTIC",
                "id" : 1
            },
            {
                "type": "supplier",
                "name": this.$t('SHARE_ORDER.rating_driver.thanksfull.on_time'),
                "image_url": "https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Badges+icon/on_time_icon.png",
                "key": "SUPPLIER_ONTIME",
                "id" : 2

            },
            {
                "type": "supplier",
                "name": this.$t('SHARE_ORDER.rating_driver.thanksfull.cute'),
                "image_url": "https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Badges+icon/cute_icon.png",
                "key": "SUPPLIER_CUTE",
                "id" : 3
            },
            {
                "type": "supplier",
                "name": this.$t('SHARE_ORDER.rating_driver.thanksfull.excellent'),
                "image_url": "https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Badges+icon/excellent_icon.png",
                "key": "SUPPLIER_EXCELLENT",
                "id" : 4
            },
            {
                "type": "supplier",
                "name": this.$t('SHARE_ORDER.rating_driver.thanksfull.polite'),
                "image_url": "https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Badges+icon/polite_icon.png",
                "key": "SUPPLIER_POLITE",
                "id" : 5
            },
            {
                "type": "supplier",
                "name": this.$t('SHARE_ORDER.rating_driver.thanksfull.careful'),
                "image_url": "https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Badges+icon/careful_icon.png",
                "key": "SUPPLIER_CAREFUL",
                "id" : 6
            }
        ]
        this.reasonPositive = [...bagdeList]

        let reasons = [
            {
                key: "reason_1",
                value: "[Driver's attitude]",
                text: this.$t("SHARE_ORDER.rating_driver.reasons.reason_1")
            },
            {
                key: "reason_2",
                value: "[Damaged / Lost Packages]",
                text: this.$t("SHARE_ORDER.rating_driver.reasons.reason_2")
            },
            {
                key: "reason_3",
                value: "[Pickup Time]",
                text: this.$t("SHARE_ORDER.rating_driver.reasons.reason_3")
            },
            {
                key: "reason_4",
                value: "[Delivery Time]",
                text: this.$t("SHARE_ORDER.rating_driver.reasons.reason_4")
            },
            {
                key: "reason_5",
                value: "[No uniforms]",
                text: this.$t("SHARE_ORDER.rating_driver.reasons.reason_5")
            },
            {
                key: "reason_6",
                value: "[Overcharging]",
                text: this.$t("SHARE_ORDER.rating_driver.reasons.reason_6")
            },
            {
                key: "reason_7",
                value: "[Different Driver]",
                text: this.$t("SHARE_ORDER.rating_driver.reasons.reason_7")
            },
        ];

        this.reasonNegative = [...reasons]

    },
    mounted() {
        if(this.initRate === PERFECT_RATE) {
            this.visibleSubmit = true
        }
    },
}
</script>
<style lang="scss" scoped>
.rating-driver{
    .stars-wrapper {
        display: flex;
        height: 54px;
        background: #FFFFFF;
        border: 1px solid #F5F5F5;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        margin-bottom: 20px;
        // justify-content: space-around;
        // align-items: center;
        .rate-des {
            width: 50%;
            line-height: 54px;
            color: #1A1A1A;
            font-weight: 500;
            padding-left: 10px;
        }
        .star-wapper{
            margin: 0 5px;
            padding: 9px 0;
        }
    }
    .label-rating{
        color: #1A1A1A;
        font-weight: 500;
    }
    .badge-rating {
        margin-top: 20px;
        .reasons {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
        }
        .reasons.equal-5-stars{
            div{
                width: 33.333333%;
                float: left;
                text-align: center;
                margin: 10px 0;
                cursor: pointer;

                img{
                    background: #EEF3F9;
                    border-radius: 50%;
                }
                img.active{
                    background: #FFE6CC;

                }
            }
            p{
                font-size: 12px;
                color: rgba(0, 0, 0, 0.65);
            }
        }
        .reasons.less-5-stars{
            .reason {
                padding: 8px 16px;
                border: 1px solid #F2F2F2;
                background: #F2F2F2;
                margin: 0 8px 8px 0;
                color: #1a1a1a;
                border-radius: 20px;
                cursor: pointer;
                span{
                    font-size: 14px;
                }
            }
            .reason.active{
                border: 1px solid #ff8200;
                color: #ff8200;
                background: rgba(255, 130, 0, 0.1);
            }
        }
    }
    .leave-feedback{
        display: flex;
        justify-content: center;
        cursor: pointer;
        margin-top: 10px;
        margin-bottom: 90px;
        span{
            color: #ff8200;
            font-weight: 600;
            font-size: 14px;
        }
    }
    .feedback-rating{
        margin-top: 10px;
        textarea {
            width: 100%;
            height: 92px;
            background-color: #f2f2f2;
            outline: none;  
            border: none;
            border-radius: 4px;
            resize: none;
            padding: 12px 0 12px 12px;
            font-size: 14px;
        }
        p{
            font-size: 14px;
            color: #7A8189;
        }
    }
    .submit {
        .btn-submit {
            width: 100%;
            height: 45px;
            border: none;
            background: #BCBCBC;
            color: #fff;
            font-weight: 500;
            font-size: 14px;
            border-radius: 4px;
            margin-top: 10px;
            outline: none;
        }
        .btn-submit.active{
            background: #ff8200;
        }
    }
}
@media only screen and (max-width: 414px) {
    .rating-driver{
        .leave-feedback{
            margin-bottom: 72px;
        }
        .feedback-rating {
            textarea{
                width: 100%;
                height: 70px;
            }
        }
    }
}
</style>